import { type UseQueryResult, useQuery } from 'react-query';
import {
  PagedResultDto_PlanListDto,
  PlanApprovalService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Plan_PlanListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetPlanManagementApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // status?: number[]
  // eslint-disable-next-line camelcase
): UseQueryResult<PagedResultDto_PlanListDto | undefined, unknown> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    planOnBoardDate,
    planEffectiveDate,
    planApprovalStatusIds,
    _force,
  } = tableInfo;
  const planApprovalList = useQuery(
    [
      'getPlanManagementApprovalList',
      planOnBoardDate,
      planEffectiveDate,
      planApprovalStatusIds,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      // if (status === 5) {
      //   status = undefined;
      // }
      return await handleRequest(
        PlanApprovalService.getApiAwardApiAppPlanApprovalPlanList(
          planOnBoardDate,
          planEffectiveDate,
          planApprovalStatusIds,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
    // {
    //   keepPreviousData: true,
    // }
  );

  return planApprovalList;
};

export default useGetPlanManagementApprovalList;
